const map = {
	"./GameChallenges_3.1_mobile.png": 3856,
	"./GameChallenges_3.3_mobile.png": 5722,
	"./GameChallenges_3.4_mobile.png": 5895,
	"./GameChallenges_5.1_mobile.png": 7446,
	"./GameChallenges_5.2_mobile.png": 4231,
	"./GameChallenges_5.3_mobile.png": 4556,
	"./GameChallenges_5.4_mobile.png": 1037,
	"./GameChallenges_5.5_mobile.png": 9370,
	"./GameChallenges_5.6_mobile.png": 6123,
	"./ssPowerRestored_mobile.png": 9812
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 754;